import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  // State
  const menuConfig = ref([])
  const isLoaderActive = ref(true)
  const theme = ref('')
  const root = ref('')
  const rootMenu = ref('')
  const showMenuLayer = ref(false)
  const layer = ref(0)
  const layerId = ref('')
  const back = ref({
    label: '',
    slug: '',
    contentType: '',
    root: '',
    id: '',
    name: 'index',
  })
  const screenWidth = ref(0)
  const isHome = ref(false)
  const headerHeight = ref(0)

  // Getters
  const getMenuConfig = computed(() =>
    menuConfig.value.length > 0
      ? menuConfig.value[0]?.menuItems?.edges || []
      : []
  )

  const getMainNav = computed(() =>
    getMenuConfig.value?.length
      ? getMenuConfig.value.map((el) => el.node.label)
      : []
  )

  const getAcademyNav = computed(() =>
    menuConfig.value.length > 0 && menuConfig.value[0]?.menuItems?.edges?.[1]
      ? menuConfig.value[0].menuItems.edges[1].node.childItems.nodes || []
      : []
  )

  const getStudiumNav = computed(() =>
    menuConfig.value.length > 0 && menuConfig.value[0]?.menuItems?.edges?.[0]
      ? menuConfig.value[0].menuItems.edges[0].node.childItems.nodes || []
      : []
  )

  const getProgramNav = computed(() =>
    menuConfig.value.length > 0 && menuConfig.value[0]?.menuItems?.edges?.[2]
      ? menuConfig.value[0].menuItems.edges[2].node.childItems.nodes || []
      : []
  )

  const getAcademyNavByID = computed(() => {
    return (id) => getAcademyNav.value?.find((item) => item.id === id) || null
  })

  const getStudiumNavByID = computed(() => {
    return (id) => getStudiumNav.value?.find((item) => item.id === id) || null
  })
  const getProgramNavByID = computed(() => {
    return (id) => getProgramNav.value?.find((item) => item.id === id) || null
  })

  const getIsHome = computed(() => isHome.value)
  const getRootMenu = computed(() => rootMenu.value)
  const getShowMenuLayer = computed(() => showMenuLayer.value)
  const getLayer = computed(() => layer.value)
  const getLayerId = computed(() => layerId.value)
  const getHeaderHeight = computed(() => headerHeight.value)
  const getIsDesktop = computed(() => screenWidth.value >= 1000)
  const getBack = computed(() => back.value)

  // Actions
  const setMenuConfig = (data) => {
    if (data) menuConfig.value = data
  }

  const setBack = (data) => {
    if (data) {
      back.value = { ...data }
    }
  }

  const setIsLoaderActive = (isActive) => {
    isLoaderActive.value = isActive
  }

  const setRoot = (data) => {
    root.value = data
  }

  const setTheme = (data) => {
    theme.value = data
  }

  const setRootMenu = (data) => {
    rootMenu.value = data
  }

  const setShowMenuLayer = (data) => {
    showMenuLayer.value = data
  }

  const setLayer = (data) => {
    layer.value = data
  }

  const setLayerId = (data) => {
    layerId.value = data
  }

  const setScreenWidth = (data) => {
    screenWidth.value = data
  }

  const setIsHome = (data) => {
    isHome.value = data
  }

  const setHeaderHeight = (data) => {
    headerHeight.value = data
  }

  const homeSwitcher = (payload) => {
    setIsHome(payload)
  }

  return {
    menuConfig,
    isLoaderActive,
    theme,
    root,
    rootMenu,
    showMenuLayer,
    layer,
    layerId,
    back,
    screenWidth,
    isHome,
    headerHeight,

    getMenuConfig,
    getMainNav,
    getAcademyNav,
    getAcademyNavByID,
    getStudiumNav,
    getStudiumNavByID,
    getProgramNav,
    getProgramNavByID,
    getIsHome,
    getRootMenu,
    getShowMenuLayer,
    getLayer,
    getLayerId,
    getHeaderHeight,
    getIsDesktop,
    getBack,

    setMenuConfig,
    setIsLoaderActive,
    setRoot,
    setTheme,
    setRootMenu,
    setShowMenuLayer,
    setLayer,
    setLayerId,
    setBack,
    setScreenWidth,
    setIsHome,
    setHeaderHeight,
    homeSwitcher,
  }
})
